import $ from "jquery";
import Backbone from "backbone";
import _ from "underscore";
import template from "./template.html";
import popupTemplate from "./popup-template.html";

import {Size} from "utils/img";

let MapView = Backbone.View.extend({
    template,
    className: "tab-pane",
    id: "sitemap",
    events: {
        "change #map-floor-selector": "changeMapFloor",
        "click .floorplan-red-dot": "toggleMap",
        "click .unit-popup-close": "closePopUp",
        "shown.bs.popover *": "updatePopoverWidth"
    },
    attributes: {
        role: "tabpanel"
    },
    initialize: function(options) {
        let cm = this.collection.first().get("community").map.filter(map => map.image);
        let currentMap = 0;
        let units = [];
        let showUnits = this.collection.some(fp => fp.getHideUnitAvailability() !== true);

        this.popoverWidth = document.documentElement.clientWidth;

        this.selectText = options.selectText || "Select a Level";
        this.apartmentType = options.apartmentType || "Apartment";

        if (showUnits) {
            this.collection.forEach((fp) => {
                let fpUnits = fp.get("units").toJSON().map(u => {u.floorPlan = fp.toJSON(); return u;});
                let maxUnits = fp.get("units_to_show");
                if (maxUnits && maxUnits < fpUnits.length) {
                    fpUnits = fpUnits.slice(-1 * maxUnits);
                }
                units = units.concat(fpUnits);
            });
        }

        this.filtered = false;
        this.maps = new Map();

        _.each(cm, (map) => {
            if (!this.maps.has(map.image)) {
                let filteredUnits = _.filter(
                    units,
                    (u) => u.red_dot && u.red_dot.image === map.image
                );
                this.maps.set(map.image, {
                    size: new Size(map.width, map.height),
                    units: filteredUnits,
                    active: currentMap == 0,
                    id: currentMap,
                    name: map.name
                });
                currentMap++;
            }
        });

        let collection = this.collection;
        let self = this;
        $("body").popover({
            selector: `#${this.id} .floorplan-red-dot`,
            container: `#${this.id}`,
            html: true,
            placement: function() {
                const hasRequiredWidth = (
                    document.documentElement.clientWidth > window.innerHeight &&
                    document.documentElement.clientWidth > 2.5 * self.popoverWidth
                );
                const placementAxis = hasRequiredWidth ? "right" : "top";

                return "auto " + placementAxis;
            },
            content: function() {
                let elem = this;
                let slug = elem.getAttribute("data-floor-plan");
                let fp = collection.findWhere({slug});

                if (fp) {
                    let units = fp.get("units");
                    let uuid = elem.getAttribute("data-unit");
                    let unit = units.findWhere({uuid});
                    if (unit) {
                        return popupTemplate({
                            unit,
                            floorPlan: fp,
                            hideUnitNumbers: fp.getHideUnitNumbers(),
                            apartmentType: self.apartmentType
                        });
                    }
                }
                return "";
            },
            template: '<div class="popover" role="tooltip"><div class="arrow"></div><span class="unit-popup-close icon-close-2" style="float: right;"></span><div class="popover-title"></div><div class="popover-content"></div></div>'
        });
    },
    render: function() {
        let context = {
            maps: this.maps,
            selectText: this.selectText
        };

        if (this.filtered && this.unit) {
            context.maps = new Map();
            let unit = this.unit.toJSON();
            unit.floorPlan = this.floorPlan.toJSON();
            let size = this.maps.get(unit.red_dot.image).size;
            context.maps.set(
                unit.red_dot.image,
                {size, units: [unit], active: true}
            );
            this.collection.once(
                "render:app",
                () => this.$el.find(".floorplan-red-dot").click()
            );
        }

        this.$el.html(this.template(context));

        this.delegateEvents();

        return this;
    },
    setFilter: function(filter) {
        this.filtered = filter;
    },
    changeMapFloor: function(e) {
        this.$el.find(".site-map-figure").addClass("hide");
        this.$el.find("#map-" + e.target.value).removeClass("hide");
    },
    updatePopoverWidth: function(e) {
        this.popoverWidth = this.$el.find(".popover").outerWidth();
    },
    toggleMap: function(e) {
        e.preventDefault();

        const unitUUID = e.target.getAttribute("data-unit");
        const redDots = this.$el.find(".floorplan-red-dot").each(function() {
            if (this.getAttribute("data-unit") != unitUUID) {
                $(this).toggleClass("hide");
            }
        });
    },
    closePopUp: function(e) {
        e.preventDefault();

        const selectedPopOver = e.target.parentElement;
        const unitUUID = $(selectedPopOver).find(".view-floor-plan").attr("href").split("/").pop();
        const redDot = this.$el.find("span[data-unit='" + unitUUID + "']");

        if (redDot) {
            redDot.trigger("click");
        }
    }
});

export {MapView};
